import React from "react";
import styled from "styled-components";
const StyledParagraph = styled.div `
    margin: 0;
    color: #4a4a4a;
`;
const Paragraph = ({ children }) => {
    return React.createElement(StyledParagraph, null, children);
};
export default Paragraph;
